import type { SVGProps } from "react";

export const BellIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className="fill-current"
  >
    <path
      d="M11.9996 4.80005C11.5018 4.80005 11.0996 5.20224 11.0996 5.70005V6.24005C9.04649 6.6563 7.49963 8.47317 7.49963 10.65V11.1788C7.49963 12.5007 7.01308 13.7775 6.13559 14.7675L5.92747 15.001C5.69122 15.2654 5.63497 15.645 5.77841 15.9685C5.92184 16.2919 6.24527 16.5 6.59965 16.5H17.3995C17.7539 16.5 18.0745 16.2919 18.2207 15.9685C18.367 15.645 18.3079 15.2654 18.0717 15.001L17.8636 14.7675C16.9861 13.7775 16.4995 12.5035 16.4995 11.1788V10.65C16.4995 8.47317 14.9527 6.6563 12.8996 6.24005V5.70005C12.8996 5.20224 12.4974 4.80005 11.9996 4.80005ZM13.2736 18.6741C13.6111 18.3366 13.7996 17.8782 13.7996 17.4H11.9996H10.1996C10.1996 17.8782 10.388 18.3366 10.7255 18.6741C11.063 19.0116 11.5215 19.2 11.9996 19.2C12.4777 19.2 12.9361 19.0116 13.2736 18.6741Z"
      fill="currentColor"
    />
  </svg>
);
